import MainLayout from "../../component/atoms/layout/mainLayout";
import MainText from "../../component/atoms/text/mainText";
import ContentLayout from "../../component/atoms/layout/contentLayout";
import DetailGoBack from "../../component/molecules/detailGoBack";

function Policy() {
  return (
    <>
      <MainLayout>
        <DetailGoBack title={"개인정보처리방침"} style={{ marginBottom: "20px" }} />
        <ContentLayout style={{ marginTop: "20px", gap: "20px" }}>
          <div style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <MainText style={{ fontSize: "15px", fontWeight: "400", lineHeight: "23px", color: "#191919" }}>
              '라스트액시트'(이하 '회사')가 운영하는 라스트액시트’은(는) 개인정보보호법 제30조 의거 이용자의
              개인정보보호와 권익을 보호하고 관련된 고충 및 애로사항을 신속하게 처리하기 위해 아래의 개인정보처리방침을
              제정·운영하고 있습니다. 회사는 관계법령에서 규정하고 있는 책임과 의무를 준수하고 실천하기 위해 최선의
              노력을 하고 있습니다 <br />
              <br />
              시행일 : 2023-10-12
              <br />
              <br />
              <span style={{ fontWeight: "600" }}>목차</span>
              <br />
              제1조 개인정보의 수집 및 이용에 관한 안내
              <br />
              제2조 추가적인 이용 제공 판단기준 <br />
              제3조 개인정보자동수집 장치의 설치와 운영거부에 관한 사항 <br />
              제4조 개인정보의 보유·이용기간 및 파기 <br />
              제5조 개인정보 처리 위탁 <br />
              제6조 개인정보의 제3자 제공 <br />
              제7조 개인정보의 안전성 확보조치 <br />
              제8조 이용자 및 법정대리인의 권리와 그 행사 방법
              <br />
              제9조 개인정보보호 책임자 및 이용자 권익침해에 대한 구제방법 <br />
              제10조 개인정보처리방침 변경에 관한 사항
              <br />
              <br />
              <span style={{ fontWeight: "600" }}>1조</span>
              <br />
              <span style={{ fontWeight: "600" }}>개인정보의 수집 및 이용에 관한 안내</span>
              <br />
              회사는 아래와 같이 제공하는 서비스에 따라 개인정보의 수집목적, 항목, 보유 및 이용기간을 달리하여
              서비스제공을 위하여 필요한 최소한의 개인정보를 수집하고 있습니다.
              <br />
              <br />
              <span style={{ fontWeight: "600" }}>- 회원가입 및 서비스 이용</span>
              <br />
              <br />
              <span style={{ fontWeight: "600" }}>수집목적</span>
              <br />
              서비스 이용 관련 상담 및 문의응대
              <br />
              <span style={{ fontWeight: "600" }}>필수 항목</span>
              <br />
              성명, 문의사항 제목, 문의사항
              <br />
              <span style={{ fontWeight: "600" }}>보유·이용기간</span>
              <br />
              회원탈퇴 후 5 일 또는관련법령에 따른 기간 까지 <br />
              <br />
              <span style={{ fontWeight: "600" }}>수집목적</span>
              <br />
              SNS 간편 회원가입 및 로그인 필수 항목 회원명/이메일/휴대전화번호
              <br />
              <span style={{ fontWeight: "600" }}>보유·이용기간</span>
              <br />
              내용회원탈퇴 후 5 일 또는관련법령에 따른 기간 까지
              <br />
              <br />
              <span style={{ fontWeight: "600" }}>수집목적</span>
              <br />
              회원가입 및 이용자 식별
              <br />
              <span style={{ fontWeight: "600" }}>필수 항목</span>
              <br />
              성명, 이메일, 비밀번호, 휴대전화번호
              <br />
              <span style={{ fontWeight: "600" }}>보유·이용기간</span>
              <br />
              내용회원탈퇴 후 5 일 또는관련법령에 따른 기간 까지
              <br />
              <br />
              <span style={{ fontWeight: "600" }}>수집목적</span>
              <br />
              부동산, 증권 등 물질적 자산 기록 및 보관
              <br />
              <span style={{ fontWeight: "600" }}>필수 항목</span>
              <br />
              이용자가 등록한 자산 관련 정보
              <br />
              <span style={{ fontWeight: "600" }}>선택 항목</span>
              <br />
              이용자가 등록한 자산 관련 기타 정보 및 첨부파일
              <br />
              <span style={{ fontWeight: "600" }}>보유·이용기간</span>
              <br />
              내용회원탈퇴 후 5 일 또는관련법령에 따른 기간 까지
              <br />
              <br />
              <span style={{ fontWeight: "600" }}>수집목적</span>
              <br />
              가족, 친구 등 전하고 싶은 글 기록 및 보관
              <br />
              <span style={{ fontWeight: "600" }}>필수 항목</span>
              <br />
              게시글명, 게시글 내용
              <br />
              <span style={{ fontWeight: "600" }}>선택 항목</span>
              <br />
              게시글 관련 첨부파일
              <br />
              <span style={{ fontWeight: "600" }}>보유·이용기간</span>
              <br />
              내용회원탈퇴 후 5 일 또는관련법령에 따른 기간 까지
              <br />
              <br />
              <span style={{ fontWeight: "600" }}>수집목적</span>
              <br />
              유언 작성 및 보관
              <br />
              <span style={{ fontWeight: "600" }}>필수 항목</span>
              <br />
              성명, 상속 내용(텍스트)
              <br />
              <span style={{ fontWeight: "600" }}>보유·이용기간</span>
              <br />
              내용회원탈퇴 후 5 일 또는관련법령에 따른 기간 까지
              <br />
              <br />
              <span style={{ fontWeight: "600" }}>기타</span>
              <br />- 회사는 만 14세 미만 아동에게 당사의 서비스를 제공하지 않으며 이와 관련한 개인정보를 수집하지
              않습니다. <br />- 회사가 처리하는 회원정보의 목적과 항목이 변경될 경우에는 관련법령에 따라 사전에 동의를
              요청합니다. <br />- 회사는 주민등록번호 처리를 원칙적으로 금지하며 업무 수행 중 법률, 대통령령, 국회규칙,
              대법원규칙,헌법재판소규칙, 중앙선거관리위원회 규칙 및 감사원규칙에서 구체적으로 주민등록번호의 처리를
              요구할 경우에만 처리하고 있습니다.
              <br /> -- 회사는 다음의 방식으로 개인정보를 수집하며 수집 전 사전동의를 획득합니다. <br />
              -- 서비스 이용 과정에서 이용자가 개인정보를 직접 입력하는 방식 <br />
              -- 박람회, 세미나, 행사진행 등 오프라인에서 서면으로 개인정보를 수집하는 방식 <br />
              -- 서비스를 이용하는 과정에 쿠키, 접속로그 등 자동으로 생성 및 수집되는 방식
              <br />
              <br />
              <span style={{ fontWeight: "600" }}>2조</span>
              <br />
              <span style={{ fontWeight: "600" }}>추가적인 이용 제공 판단기준</span>
              <br />
              회사는 개인정보보호법 제15조 제3항 및 제17조 제4항에 따라 개인정보보호법 시행령 제14조의2에 따른 사항을
              고려하여 정보주체의 동의 없이 개인정보를 추가적으로 이용 제공할 수 있습니다.이에 따라 회사는 정보주체의
              동의 없이 추가적인 이용제공을 하기 위하여 다음과 같은 사항을 고려하였습니다. 개인정보를 추가적으로 이용
              제공하려는 목적이 당초 수집 목적과 관련성이 있는지 여부 개인정보를 수집한 정황 또는 처리 관행에 비추어 볼
              때 추가적인 이용 제공에 대한 예측가능성이 있는지 여부 개인정보의 추가적인 이용제공이 정보주체의 이익을
              부당하게 침해하는지 여부 가명처리 또는 암호화 등 안전성 확보에 필요한 조치를 하였는지 여부
              <br />
              <br />
              <span style={{ fontWeight: "600" }}>3조</span>
              <br />
              <span style={{ fontWeight: "600" }}>개인정보자동수집 장치의 설치와 운영거부에 관한 사항</span>
              <br />
              회사는 서비스 이용과정에서 이용자로부터 다음과 같은 정보들이 자동으로 생성/수집되고 다음의 목적으로 이용될
              수 있습니다.
              <br />
              <br />
              <span style={{ fontWeight: "600" }}>개인정보 자동수집정보 사용목적</span>
              <br />- 관련법규의 준수
              <br />
              회사는 관련법규의 준수를 위해 이용자의 접속기록(로그인)을 보관할 의무가 있습니다.
              <br />
              <br />
              <span style={{ fontWeight: "600" }}>4조</span>
              <br />
              <span style={{ fontWeight: "600" }}>개인정보의 보유·이용기간 및 파기</span>
              <br />
              회사가 수집한 개인정보는 이용자로부터 개인정보 수집 시에 동의 받은 개인정보 보유·이용기간 내 또는
              관련법령에 따른 개인정보 보유·이용기간 내 처리하고 해당 목적이 달성 및 보유이용기간이 경과할 시에는
              지체없이 해당 개인정보를 복구 또는 재생할 수 없는 방법으로 파기합니다.
              <br />
              <br />
              <span style={{ fontWeight: "600" }}>- 이용자정보</span>
              <br />
              1. 개인정보를 수집한 이용목적을 달성한 경우 회사는 이용자의 모든 개인정보를 삭제합니다. <br />
              2. 단, 관계 법령에서 개인정보를 보존해야할 필요가 있는 경우 해당 법률의 규정에 따릅니다.
              <br />
              <br />
              <span style={{ fontWeight: "600" }}>- 관련법령에 따른 의무 보유기간</span>
              <br />
              <span style={{ fontWeight: "600" }}>보유 목적</span>
              <br />
              접속에 관한 기록 보존
              <br />
              <span style={{ fontWeight: "600" }}>근거 법령</span>
              <br />
              보존통신비밀보호법
              <br />
              <span style={{ fontWeight: "600" }}>보유 기간</span>
              <br />
              3개월
              <br />
              <br />
              <span style={{ fontWeight: "600" }}>5조</span>
              <br />
              <span style={{ fontWeight: "600" }}>개인정보의 제3자 제공</span>
              <br />
              회사는 정보주체의 개인정보를 ‘제1조 개인정보의 수집 및 이용에 관한 안내’에서 명시한 범위 내에서만
              처리하며, 이용자의 별도 사전동의, 관련법령의 특별한 요구가 발생하는 경우에만 개인정보를 제3자에게
              제공합니다.
              <br />
              <br />
              <span style={{ fontWeight: "600" }}>사전동의를 받은 제3자 제공안내</span>
              <br />
              제공받는 자제공목적제공항목보유 및 이용기간이용자가 등록한 특정인이용자 유고 시 특별한 유산에서 보관하는
              이용자의 자산 및 유언 확인이용자의 계정 정보, 이용자 개인금고의 2차 암호키이용자(초대자) 회원탈퇴 후 5 일
              또는관련법령에 따른 기간 까지
              <br />
              <br />
              <span style={{ fontWeight: "600" }}>관련법령에 근거한 사전동의 없는 제3자 제공안내</span>
              <br />
              1. 통계작성, 학술연구 또는 시장조사를 위하여 필요한 경우로서 특정 개인을 식별할 수 없는 형태로 제공하는
              경우 <br />
              2. 관계법령에 의하여 국가기관으로부터 요구받은 경우 <br />
              3. 범죄에 대한 수사상의 목적이 있거나, 정보통신 윤리위원회의 요청이 있는 경우 <br />
              4. 기타 관계법령에서 정한 절차에 따른 요청이 있는 경우
              <br />
              <br />
              <span style={{ fontWeight: "600" }}>6조</span>
              <br />
              <span style={{ fontWeight: "600" }}>개인정보의 안전성 확보조치</span>
              <br />
              회사는 이용자의 개인정보를 안전하게 관리하여 개인정보가 분실, 도난, 유출, 변조 또는 훼손되지 않도록 최선을
              다하고 있으며 필요한 기술적, 관리적 및 물리적 조치를 하고 있습니다.
              <br />
              <br />
              <span style={{ fontWeight: "600" }}>개인정보 취급 직원의 최소화 및 교육</span>
              <br />
              개인정보를 취급하는 직원을 최소화하고, 주기적인 개인정보 보호 교육을 실시하여 개인정보를 관리하는 대책을
              시행하고 있습니다.
              <br />
              <br />
              <span style={{ fontWeight: "600" }}>내부관리계획의 수립 및 시행</span>
              <br />
              개인정보의 안전한 처리를 위하여 내부관리계획을 수립하고 시행하고 있습니다.
              <br />
              <br />
              <span style={{ fontWeight: "600" }}>접속기록의 보관 및 위변조 방지</span>
              <br />
              개인정보 침해사고 발생 시 대응이 용이하도록 개인정보처리시스템에 접속한 기록(웹 로그, 요약정보 등)을 최소
              1년 이상 보관, 관리하고 있으며, 접속 기록이 위변조 및 도난, 분실되지 않도록 보안기능을 사용하고 있습니다.
              <br />
              <br />
              <span style={{ fontWeight: "600" }}>개인정보의 암호화</span>
              <br />
              이용자의 개인정보는 암호화 되어 저장 및 관리되고 있습니다.
              <br />
              <br />
              <span style={{ fontWeight: "600" }}>해킹 등에 대비한 기술적 대책</span>
              <br />
              회사는 해킹이나 컴퓨터 바이러스 등에 의한 개인정보 유출 및 훼손을 막기 위하여 보안프로그램을 설치하고
              주기적인 갱신·점검을 합니다. 또한 외부로부터 접근이 통제된 구역에 시스템을 설치하고 기술적/물리적으로 감시
              및 차단하고 있습니다.
              <br />
              <br />
              <span style={{ fontWeight: "600" }}>개인정보에 대한 접근통제 제한</span>
              <br />
              개인정보를 처리하는 개인정보처리시스템에 대한 접근권한의 부여, 변경, 말소를 통하여 개인정보에 대한
              접근통제를 위한 조치를 하고 있습니다.
              <br />
              <br />
              <span style={{ fontWeight: "600" }}>7조</span>
              <br />
              <span style={{ fontWeight: "600" }}>이용자 및 법정대리인의 권리와 그 행사 방법</span>
              <br />
              회사는 이용자(또는 법정대리인)의 개인정보 권리를 보호하기 위해 아래와 같이 행사 방법을 마련하고 있습니다.
              <br />
              <br />
              <span style={{ fontWeight: "600" }}>이용자의 권리 및 행사방법</span>
              <br />
              1. 회원탈퇴 또는 삭제요청 : 더보기 → 회원탈퇴 <br />
              2. 그 밖에 서면, 전자우편 등을 통하여 개인정보의 처리 정지 및 삭제를 요구할 수 있습니다. <br />
              3. 회사는 개인정보의 오류 등에 대한 정정 또는 삭제를 요청한 경우에는 정정 또는 삭제를 완료하기 전까지 당해
              개인정보를 이용하거나 제공하지 않습니다. <br />
              4. 개인정보의 정정 및 삭제 요구는 다른 법령에서 그 개인정보가 수집 대상으로 명시되어 있는 경우에는 당해
              개인정보의 삭제를 요구할 수 없습니다. <br />
              5. 회사는 이용자 권리에 따른 열람의 요구, 정정·삭제의 요구, 처리정지의 요구 시 열람 등 요구를 한 자가
              본인인지를 확인합니다.
              <br />
              <br />
              <span style={{ fontWeight: "600" }}>법정대리인의 권리 및 행사방법</span>
              <br />
              1. 이용자의 법정대리인이나 위임을 받은 자 등 대리인이 이용자의 권리(열람, 정정, 처리정지, 삭제)를 행사하는
              경우 개인정보보호법 시행규칙 별지 제11호 서식에 따른 위임장을 제출해야 합니다. <br />
              2. 회사는 이용자 권리에 따른 열람의 요구, 정정·삭제의 요구, 처리정지의 요구 시 열람 등 요구를 한 자가
              정당한 대리인인지를 확인합니다.
              <br />
              <br />
              <span style={{ fontWeight: "600" }}>8조</span>
              <br />
              <span style={{ fontWeight: "600" }}>개인정보보호 책임자 및 이용자 권익침해에 대한 구제방법</span>
              <br />
              회사는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 이용자의 불만처리 및 피해구제
              등을 위하여 아래와 같이 개인정보보호책임자를 지정하고 있습니다.
              <br />
              <br />
              <span style={{ fontWeight: "600" }}>개인정보보호 책임자</span>
              <br />
              성명 : 조용진
              <br />
              직책 : 대표 <br />
              연락처 : msjin3469@naver.com <br />
              개인정보보호 책임자의 역할 이용자는 서비스를 이용하면서 발생한 모든 개인정보보호 관련 문의, 불만처리,
              피해구제 등에 관한 사항을 개인정보보호책임자에게 문의하실 수 있습니다. 회사는 이용자의 문의에 대해 지체
              없이 답변 및 처리해드릴 것입니다.
              <br />
              <br />
              <span style={{ fontWeight: "600" }}>권익침해관련 도움받을수 있는 기관</span>
              <br />
              이용자의 권익침해 관련 자세한 도움이 필요하시면 아래 기관에 문의하여 주시기 바랍니다. <br />
              <br />
              1. 개인정보 침해신고센터 (한국인터넷진흥원 운영) - 소관업무 : 개인정보 침해사실 신고, 상담 신청 - 홈페이지
              : privacy.kisa.or.kr - 전화 : (국번없이) 118 - 주소 : (58324) 전남 나주시 진흥길 9(빛가람동 301-2) 3층
              개인정보침해신고센터 <br />
              2. 개인정보 분쟁조정위원회 - 소관업무 : 개인정보 분쟁조정신청, 집단분쟁조정 (민사적 해결) - 홈페이지 :
              www.kopico.go.kr - 전화 : (국번없이) 1833-6972 - 주소 : (03171) 서울특별시 종로구 세종대로 209
              정부서울청사 4층 <br />
              3. 대검찰청 사이버범죄수사단 - 전화 : 02-3480-3573 - 홈페이지 : www.spo.go.kr 4. 경찰청 사이버안전국 -
              전화 : 182 - 홈페이지 : cyberbureau.police.go.kr
              <br />
              <br />
              <span style={{ fontWeight: "600" }}>9조</span>
              <br />
              <span style={{ fontWeight: "600" }}>개인정보처리방침 변경에 관한 사항</span>
              <br />
              개인정보처리방침은 시행일로부터 적용되며, 관련법령 및 방침에 따른 변경내용의 추가, 삭제 및 정정이 있는
              경우에는 지체없이 홈페이지를 통하여 고지할 것입니다.
            </MainText>
          </div>
        </ContentLayout>
      </MainLayout>
    </>
  );
}

export default Policy;
